<div class="dialog--print">
  <div class="dialog__content">
    <div class="dialog__title">{{ 'webPos.ProcessingDocument' | translate }}</div>
    <div class="dialog__message">{{ 'webPos.ProcessingDocumentDescription' | translate }}</div>
    <div class="dialog__actions">
      
    </div>
  </div>
</div>
